<template>
  <div class="main">
    <div class="main_top">
      <div>
        <el-select
          v-model="params.roleid"
          placeholder="请选择角色"
          @change="GetUserList"
          clearable
        >
          <el-option
            v-for="item in roleDataList"
            :key="item.roleid"
            :label="item.rolename"
            :value="item.roleid"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="params.specid"
          @change="GetUserList"
          placeholder="请选择专业"
          clearable
        >
          <el-option
            v-for="item in majorList"
            :key="item.orgid"
            :label="item.orgname"
            :value="item.orgid"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="params.classid"
          placeholder="请选择班级"
          @change="GetUserList"
          clearable
        >
          <el-option
            v-for="item in classList"
            :key="item.orgid"
            :label="item.orgname"
            :value="item.orgid"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="params.keyword"
          placeholder="请输入账号/学(工)号/姓名/手机号"
          style="width: 200px"
          @change="GetUserList"
        ></el-input>
      </div>
      <div>
        <Model msg="新增" icon="md-add" @GetUserList="GetUserList"></Model>
        <Model
          msg="编辑"
          icon="ios-create"
          :usertem="usertem"
          @GetUserList="GetUserList"
        ></Model>
        <!-- <Button
          icon="md-trash"
          @click="deluser"
        >
          删除
        </Button> -->
        <Button icon="md-cloud-upload" @click="ExportUser">用户导出</Button>
        <Button icon="md-albums" @click="GetImportTemp">导入模板下载</Button>
        <el-upload
          class="upload-demo"
          :action="action"
          :headers="headers"
          :on-change="ImportUser"
        >
          <Button icon="md-archive">导入用户信息</Button>
        </el-upload>
        <Button icon="md-trash" @click="resetPw">重置密码</Button>
        <Dropdown @on-click="droChange" class="dropdown">
          <Icon type="md-list" />
          <a href="javascript:void(0)">
            更多操作
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="启用">启用</DropdownItem>
            <DropdownItem name="禁用">禁用</DropdownItem>
            <DropdownItem name="菜单授权">菜单授权</DropdownItem>
            <!-- <DropdownItem name="功能授权">功能授权</DropdownItem> -->
            <DropdownItem name="批量修改班级">批量修改班级</DropdownItem>
          </DropdownMenu>
        </Dropdown>

        <el-dialog :title="diatitle" :visible.sync="dialogVisible" width="30%">
          <el-tree
            :data="userTreeData"
            :default-checked-keys="checkmodule"
            :props="props"
            node-key="moduleid"
            ref="treeRef"
            show-checkbox
            accordion
            @check-change="userTreeChange"
          >
          </el-tree>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="userTreeBtn">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="main_body">
      <Table
        highlight-row
        @on-current-change="userChange"
        :columns="columns8"
        :data="userDataList"
        stripe
        ref="userTable"
      ></Table>
      <div>
        <el-pagination
          style="text-align: right; margin-top: 20px"
          :hide-on-single-page="true"
          :total="total"
          :page-size="params.pagesize"
          :current-page="params.pageindex"
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="批量修改班级"
      :visible.sync="modifydialogVisible"
      width="30%"
      center
    >
      <el-row>
        <span>原班级：</span>
        <el-cascader
          placeholder="请选择原班级"
          :options="specClassTree"
          v-model="oldclassid"
          :props="{
            expandTrigger: 'hover',
            label: 'orgname',
            value: 'orgid',
            emitPath: false,
          }"
          clearable
          filterable
        ></el-cascader>
      </el-row>
      <el-row>
        <span>新班级：</span>
        <el-cascader
          placeholder="请选择新班级"
          :options="specClassTree"
          v-model="newclassid"
          :props="{
            expandTrigger: 'hover',
            label: 'orgname',
            value: 'orgid',
            emitPath: false,
          }"
          clearable
          filterable
        ></el-cascader>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifydialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="UpdateClass()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../api/index";
import Model from "../../components/jurisdiction/userModal";
import base from "../../api/base";

export default {
  data() {
    return {
      columns8: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
          tooltip: true,
        },
        {
          title: "账号",
          key: "account",
          align: "center",
          tooltip: true,
        },
        {
          title: "姓名",
          key: "username",
          align: "center",
          width: 120,
          tooltip: true,
        },
        {
          title: "性别",
          key: "gendername",
          align: "center",
          width: 120,
          tooltip: true,
        },
        {
          title: "专业",
          key: "specnames",
          align: "center",
          tooltip: true,
        },
        {
          title: "班级",
          key: "classnames",
          align: "center",
          tooltip: true,
        },
        {
          title: "用户角色名称",
          key: "rolename",
          align: "center",
          width: 120,
          tooltip: true,
        },
        {
          title: "状态",
          key: "isenablename",
          align: "center",
          width: 120,
          tooltip: true,
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
          width: 150,
          tooltip: true,
        },
        {
          title: "备注",
          key: "description",
          align: "center",
          tooltip: true,
        },
      ],
      dialogVisible: false,
      modifydialogVisible: false,
      diatitle: "",
      userSearch: "",
      userDataList: [],
      roleDataList: [],
      classList: [],
      majorList: [],
      total: 1, //分页总条数
      usertem: {}, //用户选中项
      specialtynList: [],
      userTreeData: [], //用户授权树形
      checkmodule: [], //默认选中
      props: {
        label: "modulename",
        children: "children",
      },
      specClassTree: [],
      oldclassid: "",
      newclassid: "",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      action: base.qa + "/User/ImportUser",
      params: {
        roleid: "",
        specid: "",
        classid: "",
        keyword: "",
        pageindex: 1, //当前页
        pagesize: 13, //每页显示数
      },
    };
  },
  components: {
    Model: Model,
  },
  created() {
    this.GetUserList();
    this.GetRoleList();
    this.GetspecialtynList();
  },
  methods: {
    //用户表格选中项
    userChange(val) {
      this.usertem = val;
    },
    //获取用户列表
    async GetUserList() {
      const res = await Api.user.GetUserList(this.params);
      if (!res.success) return this.$Message.error("获取用户列表失败!");
      this.userDataList = res.rows;
      this.total = res.total;
      if (this.params.specid != "") {
        this.GetClassList();
      }
    },
    // 获取角色列表
    async GetRoleList() {
      const res = await Api.role.GetDataList(1, 100);
      if (!res.success) return this.$Message.error("获取角色列表失败!");
      this.roleDataList = res.rows;
    },
    //专业列表
    async GetspecialtynList() {
      const res = await Api.organization.GetspecialtynList();
      if (res.success != true) return this.$Message.info(res.msg);
      this.majorList = res.rows;
    },
    // 获取班级列表
    async GetClassList() {
      const req = await Api.organization.GetClassList(this.params.specid);
      if (req.success != true) return this.$Message.info(req.msg);
      this.classList = req.rows;
    },
    //专业班级树形列表
    async GetspecClassTreeList() {
      const res = await Api.organization.GetOrgDataTree();
      if (res.success != true) return this.$Message.info(res.msg);
      this.specClassTree = res.rows;
    },
    //更多按钮选择
    async droChange(val) {
      if (val == "菜单授权") {
        if (JSON.stringify(this.usertem) == "{}")
          return this.$Message.info("请选择要授权的用户！");
        const res = await Api.user.GetUserDataTree(this.usertem.userid);
        if (res.success != true) return this.$Message.info(res.msg);

        this.userTreeData = res.rows.module;
        this.checkmodule = res.rows.checkmodule;
        this.diatitle = "菜单授权";
        this.dialogVisible = true;
      } else if (val == "功能授权") {
        if (JSON.stringify(this.usertem) == "{}")
          return this.$Message.info("请选择要授权的用户！");
        const res = await Api.user.GetUserModuleAndBtns(this.usertem.userid);
        if (res.success != true) return this.$Message.info(res.msg);
        this.userTreeData = res.rows.module;
        this.checkmodule = res.rows.checkmodule;
        this.diatitle = "功能授权";
        this.dialogVisible = true;
      } else if (val == "启用" || val == "禁用") {
        if (JSON.stringify(this.usertem) == "{}")
          return this.$Message.info("请选择要操作的用户！");
        let params = {};
        params.userid = this.usertem.userid;
        if (val == "启用") {
          params.isenable = 1;
          const res = await Api.user.IsEnableUser(params);
          if (res.success != true) return this.$Message.info(res.msg);
          this.$Message.success(res.msg);
        } else if (val == "禁用") {
          params.isenable = 0;
          const res = await Api.user.IsEnableUser(params);
          if (res.success != true) return this.$Message.info(res.msg);
          this.$Message.success(res.msg);
        }
        this.usertem = {};
        this.GetUserList();
      } else if (val == "批量修改班级") {
        this.modifydialogVisible = true;
        this.GetspecClassTreeList();
      }
    },
    userTreeChange(data, checked) {
      if (checked) {
        data.ischeck = checked;
      }
    },
    async userTreeBtn() {
      let moduleids = [...this.$refs.treeRef.getCheckedKeys()];

      let res;
      if (this.diatitle == "菜单授权") {
        const params = {
          userid: this.usertem.userid,
          moduleids: moduleids,
        };
        res = await Api.user.SaveUserData(params);
      } else if (this.diatitle == "功能授权") {
        const params = {
          userid: this.usertem.userid,
          buttonids: moduleids,
        };
        res = await Api.user.SaveUserButtons(params);
      }
      if (res.success != true) return this.$Message.info(res.msg);
      this.$Message.success(res.msg);
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.params.pageindex = val;
      this.GetUserList();
    },
    //删除用户
    async deluser() {
      if (JSON.stringify(this.usertem) == "{}")
        return this.$Message.info("请选择要删除的用户！");

      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await Api.user.DelUser([this.usertem.userid]);
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.GetUserList();
          }
          this.GetSchoolTreeList();
        })
        .catch(() => {});
    },
    //重置密码
    async resetPw() {
      if (JSON.stringify(this.usertem) == "{}")
        return this.$Message.info("请选择要删除的用户！");
      const res = await Api.user.ResetPwd(this.usertem.userid);
      if (res.success != true) return this.$Message.info(res.msg);
      this.$Message.success(res.msg);
    },
    //导入模板
    async GetImportTemp() {
      const res = await Api.user.GetImportTemp();
      if (res.success != true) return this.$Message.info(res.msg);
      window.location.href = res.rows;
    },
    //导入用户信息
    async ImportUser(e) {
      if (!e.response.success) return this.$message.info(e.response.msg);
    },
    // 导出用户
    async ExportUser() {
      const res = await Api.user.ExportUser(this.params);
      console.log(res);
      window.open(res.rows);
    },
    async UpdateClass() {
      if (this.oldclassid == "" || this.newclassid == "")
        return this.$message.warning("请选择要修改的班级！");
      this.$confirm("是否确认按所选班级修改用户信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {
            oldclassid: this.oldclassid,
            newclassid: this.newclassid,
          };
          const res = await Api.user.UpdateClass(data);
          if (!res.success) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.modifydialogVisible = false;
          this.GetUserList();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    .dropdown {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      line-height: 1.5;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      height: 32px;
      line-height: 29px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      transition: color 0.2s linear, background-color 0.2s linear,
        border 0.2s linear, box-shadow 0.2s linear;
      color: #515a6e;
      background-color: #fff;
      border-color: #dcdee2;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
  /deep/.ivu-table th {
    background-color: #fff;
  }
}
</style>